import type { PriceId, ProductType, Weight } from '@iheartjane/types';

import { getMenuPrices } from '../getMenuPrices';

export interface GetCartItemWeightProps {
  price_id?: PriceId;
  type?: ProductType | null;
}

export const getCartItemWeight = (product: GetCartItemWeightProps) => {
  if (!product.type || !product.price_id) {
    return '';
  }
  const price = getMenuPrices(product.type).find(
    (label: Weight) => label.id === product.price_id
  );

  return (price && price.label) || '';
};
